// 레지스트리를 배열로 펼친다 — 코어는 이 배열만 보고 개별 플러그인 이름을 모른다
import { isPluginDefinition, type AnyPlugin } from './plugin-runtime/contract';
import * as registry from './plugin-registry';

// 레지스트리에서 플러그인 계약을 만족하는 export 만 고른다 — 헬퍼를 export 해도 플러그인으로 오인하지 않는다
export const plugins: readonly AnyPlugin[] = Object.values(registry).filter(isPluginDefinition);
